export default {
  headerText: 'Upload your logo variations',
  subHeaderText: 'Add multiple versions of your company logo to use across different contexts and formats.',
  errors: {
    logoLoadError: 'Failed to load logo',
    uploadFailed: 'Failed to upload logo',
    deleteFailed: 'Failed to delete logo',
    readingFileError: 'Failed to read file',
  },
  validationErrors: {
    maxSize: 'File size must not exceed 5MB.',
    fileType: 'File type must be JPEG, JPG, or PNG.',
    minDimensions: 'Image must be at least {{min}}x{{min}}px.',
    maxDimensions: 'Image must be smaller than {{max}}x{{max}}px.',
    aspectRatio: 'Image must be square (1:1 aspect ratio).',
    unableToValidate: 'The selected file could not be validated.',
  },
  variants: {
    jobListing: {
      title: 'Job Listing Logo',
      description:
        'Add a square version of your logo that will show up on job listings. Ensure your image is 700x700 pixels (between 300x300 and 1000x1000 pixels), in JPG, PNG, or JPEG format, and must not exceed 5MB in size.',
    },
    fullLogo: {
      title: 'Full Logo',
      description: 'Add the full version of your company logo in JPG, PNG, or JPEG format, and must not exceed 5MB in size.',
    },
  },
  uploadButton: {
    validating: 'Checking...',
    uploading: 'Uploading...',
    label: 'Upload',
    successMessage: 'Logo uploaded successfully.',
  },
  deleteButton: {
    label: 'Delete',
    alertHeader: 'Remove {{logoTitle}}',
    alertBody: 'This will remove your current {{logoTitle}}. You can upload a new one at any time.',
    alertCancel: 'Cancel',
    alertConfirm: 'Remove',
    loadingText: 'Removing...',
    successMessage: 'Logo removed successfully.',
  },
};
